export const appConfig = {
  uri: process.env.REACT_APP_URI,
  persistenceKey: process.env.REACT_APP_PERSISTENCE_KEY,
  pageTitleSuffix: process.env.REACT_APP_PAGE_TITLE_SUFFIX,
  fallbackLanguage: 'cs',
  supportedLanguages: ['cs'],
  supportEmail: 'shopify@soundsgood.agency',
  slackNotifyChannel: 'gopay',
}
